import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

export type TypeCheckValidJuminNoResponse = {
  code: string;
  message: string;
};

/**
 * @description 주민번호 유효성 검사 api 요청에 사용되는 커스텀 훅
 */
export const useCheckValidJuminNo = () => {
  const queryClient = useQueryClient();

  const requestCheckValidJuminNo = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: { juminNo: string };
    onSuccess?: (res: TypeCheckValidJuminNoResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    const endpoint = '/labor-accounts/privacy-info/jumin-no/verify';
    const queryKey = ['verify', 'juminNo', params.juminNo.split('-')[0]] as const;

    const query = queryClient.ensureQueryData<AxiosResponse<TypeCheckValidJuminNoResponse>>({
      queryKey,
      queryFn: () => axiosInstance.post(endpoint, { juminNo: params.juminNo }),
      gcTime: 15 * 60 * 1000, // 15분
      staleTime: 15 * 60 * 1000, // 15분
    });

    return requestHelper(() => query, onSuccess, onError, undefined, { showLoading: false });
  };

  return requestCheckValidJuminNo;
};
